/* eslint-disable promise/param-names */
import {
  AUTH_REQUEST,
  AUTH_ERROR,
  AUTH_SUCCESS,
  AUTH_LOGOUT,
  AUTH_RESTAPI,
  AUTH_INITIALIZE
} from "../actions/auth";
import { USER_REQUEST } from "../actions/user";
import apiCall from "../../utils/api";
import axios from 'axios'

const state = {
  token: localStorage.getItem("user-token") || "",
  status: "",
  credentials: {},
  hasLoadedOnce: false,
  RESTAPI: "",
};

const getters = {
  isAuthenticated: state => !!state.token,
  authStatus: state => state.status,
  authToken: state => state.token,
  authCredentials: state => state.credentials,
};

const actions = {
  [AUTH_REQUEST]: ({ commit, dispatch }, user) => {
    console.log("AUTH_REQUEST-user");
    console.log(user);

    return new Promise((resolve, reject) => {
      var URI = state.RESTAPI + "/app/Auth"
      const options = {
        headers: {'X-APP': 'Dali-Atomicus-Picasso-Guernica-4151452-480BCE'}
      };
      commit(AUTH_REQUEST);
      axios
        .post(URI, {email: user.username, password: user.password },options)
        .then(resp => {
          console.log(resp);

          if( resp.data.isauthenticated) {
          localStorage.setItem("user-token", resp.data.token);
          // Here set the header of your ajax library to the token value.
          // example with axios
          // axios.defaults.headers.common['Authorization'] = resp.token
          var auth = { respdata: resp.data, credentials: {email: user.username, password: user.password }   }
          commit(AUTH_SUCCESS, auth);
          dispatch(USER_REQUEST);
          resolve(resp);
        } else {
          localStorage.removeItem("user-token");
          dispatch(AUTH_LOGOUT);
          resolve(resp);

        }
        })
        .catch(err => {
          commit(AUTH_ERROR, err);
          localStorage.removeItem("user-token");
          reject(err);
        });
        /*
      apiCall({ url: "auth", data: user, method: "POST" })
        .then(resp => {
          localStorage.setItem("user-token", resp.token);
          // Here set the header of your ajax library to the token value.
          // example with axios
          // axios.defaults.headers.common['Authorization'] = resp.token
          commit(AUTH_SUCCESS, resp);
          dispatch(USER_REQUEST);
          resolve(resp);
        })
        .catch(err => {
          commit(AUTH_ERROR, err);
          localStorage.removeItem("user-token");
          reject(err);
        });
        */
    });
  },
  [AUTH_LOGOUT]: ({ commit }) => {
    return new Promise(resolve => {
      commit(AUTH_LOGOUT);
      localStorage.removeItem("user-token");
      resolve();
    });
  },
  [AUTH_INITIALIZE]: ({ commit }) => {
    return new Promise(resolve => {
      if( !state.hasLoadedOnce) {
      commit(AUTH_INITIALIZE);
      localStorage.removeItem("user-token");
      }
      resolve();
    });
  }
};

const mutations = {
  [AUTH_REQUEST]: state => {
    state.status = "loading";
  },
  [AUTH_RESTAPI]: (state, api) => {
    console.log("AUTH_RESTAPI");
    console.log(api);
    state.RESTAPI = api;

  },
  [AUTH_SUCCESS]: (state, auth) => {
    console.log("AUTH_SUCESS");
    console.log(auth);

    state.status = "success";
    state.token = auth.respdata.token;
    state.credentials = auth.credentials;
    state.hasLoadedOnce = true;
  },
  [AUTH_ERROR]: state => {
    state.status = "error";
    state.hasLoadedOnce = true;
  },
  [AUTH_LOGOUT]: state => {
    console.log("AUTH_LOGOUT:",state.token)
    console.log("AUTH_LOGOUT:",state.credentials)
    state.token = "";
    state.credentials = {};
  },
  [AUTH_INITIALIZE]: state => {
    console.log("AUTH_INITIALIZE:",state.token)
    console.log("AUTH_INITIALIZE:",state.credentials)
    if( !state.hasLoadedOnce) {
    state.token = "";
    state.credentials = {};
    state.hasLoadedOnce = true;
    }
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/auth.js